import { Outlet } from 'react-router-dom'
import {ContentArea} from '@/components/shared/ContentArea'
import {InlineRow} from '@/components/shared/InlineRow'
import { useAuth } from '@/contexts/auth-context'
import { usePageTitle } from '@/hooks/use-page-title'
import { JobBreadcrumbs } from '@/components/shared/JobBreadcrumbs'
import { useI18n } from '@/i18n'
import { SidebarNav, type SidebarNavItem } from '@/components/layout/SidebarNav'
import { SidebarNavId } from '@/testids/SidebarNavTestIds'
import { routes } from '@/lib/routes'
import { permissions } from '@/lib/permissions'
import { CONCEPT_ICON } from '@/lib/concepts'
import {SectionContainer} from '@/components/shared/SectionContainer'

export function BackgroundJobs() {
  const i18n = useI18n()
  usePageTitle(i18n.backgroundJobs.pageTitle)
  const { hasPermission } = useAuth()

  const menuItems: (SidebarNavItem & { permission: string })[] = [
    {
      id: SidebarNavId.JobsDashboard,
      title: i18n.backgroundJobs.dashboard as string,
      href: routes.backgroundJobs.dashboard.path(),
      icon: CONCEPT_ICON.dashboard,
      description: i18n.backgroundJobs.dashboardDesc as string,
      permission: permissions.jobs.view,
    },
    {
      id: SidebarNavId.Jobs,
      title: i18n.backgroundJobs.jobs as string,
      href: routes.backgroundJobs.jobs.list(),
      icon: CONCEPT_ICON.backgroundJob,
      description: i18n.backgroundJobs.jobsDesc as string,
      permission: permissions.jobs.view,
    },
    {
      id: SidebarNavId.Executions,
      title: i18n.backgroundJobs.executions as string,
      href: routes.backgroundJobs.executions.list(),
      icon: CONCEPT_ICON.jobExecution,
      description: i18n.backgroundJobs.executionsDesc as string,
      permission: permissions.jobs.view,
    },
    {
      id: SidebarNavId.Cluster,
      title: i18n.backgroundJobs.cluster as string,
      href: routes.backgroundJobs.cluster.path(),
      icon: CONCEPT_ICON.clusterNode,
      description: i18n.backgroundJobs.clusterDesc as string,
      permission: permissions.cluster.view,
    },
    {
      id: SidebarNavId.ErrorLogs,
      title: i18n.backgroundJobs.errorLogs as string,
      href: routes.admin.errorLogs.list(),
      icon: CONCEPT_ICON.errorLog,
      description: i18n.backgroundJobs.errorLogsDesc as string,
      permission: permissions.errorLogs.view,
    },
  ]

  const visibleMenuItems = menuItems.filter(item => hasPermission(item.permission))

  return (
    <SectionContainer>
      <InlineRow align="start">
        <SidebarNav items={visibleMenuItems} aria-label={String(i18n.backgroundJobs.pageTitle)}/>

        {/* Content Area */}
        <ContentArea>
          <JobBreadcrumbs />
          <Outlet />
        </ContentArea>
      </InlineRow>
    </SectionContainer>
  )
}
